export default "__VITE_ASSET__D_xnsQym__"